<template>
  <fieldset>
    <FormulateInput
      name="reasonofterminationselected"
      :options="{
        quality: i18n.form.labels.reasonofterminationoptions.quality,
        situation: i18n.form.labels.reasonofterminationoptions.situation,
        cost: i18n.form.labels.reasonofterminationoptions.cost,
        undisclosed: i18n.form.labels.reasonofterminationoptions.undisclosed,
        other: i18n.form.labels.reasonofterminationoptions.other,
      }"
      type="radio"
      :label="i18n.form.labels.reasonoftermination"
      validation="required"
      :validation-messages="i18n.form.validations.reasonoftermination"
    />
    <FormulateInput
      v-if="showReasonInput"
      name="reasonofterminationotherreason"
      type="textarea"
      validation="bail|required|nohtml"
      :validation-messages="i18n.form.validations.reasonofterminationotherreason"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsReasonOfTermination',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showReasonInput() {
      return this.model.reasonofterminationselected === 'other';
    },
  },
};
</script>
